module.exports = __webpack_public_path__ + "img/ill_spot_unavailable_location.51fdd454.svg";